export default __webpack_public_path__ + "static/rm-7bfb63e834d5d8ba71066eb21ba2e3eb.jpg";